<template>
  <div v-if="isHumanizConferencing">
    <div
      v-if="eventIsOver && !isReady"
      class="h-[440px] border rounded-lg border-gray-300 bg-gray-200 flex flex-col items-center justify-center"
    >
      <header class="text-lg font-bold">Your recording will be available soon.</header>
      <p class="text-gray-700 text-sm mt-3 text-center">
        We are processing your interview and the recording will be available shortly.
      </p>
    </div>
    <div v-else>
      <iframe
        v-if="showDaily"
        :src="contactEventLocation"
        allow="microphone; camera; display-capture;"
        class="h-[440px] border rounded-lg border-gray-300 bg-gray-200 w-full"
      />
      <div
        v-else
        class="h-[440px] border rounded-lg border-gray-300 bg-gray-200 flex flex-col items-center justify-center"
      >
        <TButton color="indigo" size="md" @click="showDaily = true">
          <vue-feather type="video" size="16" /> Join interview
        </TButton>
        <p class="text-gray-700 text-sm mt-3">
          Your call recording with coaching insights will be available here after the interview.
        </p>
      </div>
    </div>
  </div>
  <div
    v-else
    class="h-[440px] border rounded-lg border-gray-300 bg-gray-200 flex flex-col items-center justify-center p-12"
  >
    <header class="text-lg font-bold">You aren't using Humaniz Conferencing 😢</header>
    <p class="text-gray-700 text-sm mt-3 text-center">
      Did you know you can conduct your interviews via Humaniz Conferencing and automatically get recordings,
      transcripts, summaries, and post-call coaching?
    </p>
    <router-link
      class="mt-5 text-sm font-medium text-indigo-600 hover:text-indigo-500"
      to="/settings/company/scheduling"
      >Enable Humaniz Conferencing</router-link
    >
  </div>
</template>

<script>
export default {
  props: {
    contactEventLocation: {
      type: String,
      required: true,
    },
    isHumanizConferencing: {
      type: Boolean,
      required: true,
    },
    event: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showDaily: false,
    };
  },
  computed: {
    eventIsOver() {
      const now = new Date();
      return new Date(this.event.start_time) <= now && new Date(this.event.end_time) <= now;
    },
  },
};
</script>
